var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { tap, switchMap, map, withLatestFrom, mergeMap } from 'rxjs/operators';
import { LoopBackAuth, MemberApi, OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Staff } from '../actions/index';
import * as selectors from '../reducers/index';
var StaffEffects = /** @class */ (function () {
    function StaffEffects(store, actions$, api, members, auth) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.api = api;
        this.members = members;
        this.auth = auth;
        this.paginate = this.actions$.ofType(Staff.PAGE_CHANGE).pipe(map(function (action) { return Staff.RequestAllAction; }));
        this.updateFilter = this.actions$
            .ofType(Staff.UPDATE_FILTER)
            .pipe(map(function (action) { return Staff.RequestPageAction(); }));
        this.updatePagination = this.actions$.ofType(Staff.RESET_PAGE, Staff.REQUEST_PAGE).pipe(tap(function (action) {
            _this.store.dispatch(Staff.RequestCountAction());
            _this.store.dispatch(Staff.RequestAllAction);
        }));
        this.getStaff = this.actions$.ofType(Staff.REQUEST_ALL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)), this.store.select(selectors.getPageination(selectors.STAFF)), this.store.select(selectors.getFilter(selectors.STAFF))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1], pagination = _a[2], filter = _a[3];
            return _this.api
                .listMembers(organisationId, __assign({}, filter, { limit: pagination.pageSize, skip: pagination.pageSize * pagination.pageIndex }))
                .map(function (payload) {
                return Staff.ResponseSuccessAllAction(payload);
            })
                .catch(function (err) { return observableOf(Staff.ResponseFailAllAction(err)); });
        }));
        this.searchStaff = this.actions$.ofType(Staff.REQUEST_SEARCH).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.api
                .listMembers(organisationId, action.payload)
                .map(function (result) { return Staff.ResponseSuccessSearchAction(result); })
                .catch(function (err) { return observableOf(Staff.ResponseFailSearchAction(err)); });
        }));
        this.countStaff = this.actions$.ofType(Staff.REQUEST_COUNT).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)), this.store.select(selectors.getPageination(selectors.STAFF))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1], pagination = _a[2];
            return _this.api
                .countMembers(organisationId, {})
                .map(function (payload) {
                return Staff.ResponseSuccessCountAction(payload.count);
            })
                .catch(function (err) { return observableOf(Staff.ResponseFailCountAction(err)); });
        }));
        this.staffById = this.actions$.ofType(Staff.REQUEST_BY_ID).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), mergeMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.members
                .profile(action.payload.id, function (headers) {
                headers = headers.append('Organisation-Id', organisationId);
                return headers;
            })
                .map(function (payload) {
                return Staff.ResponseSuccessByIdAction(payload);
            })
                .catch(function (err) {
                return observableOf(Staff.ResponseFailByIdAction(err));
            });
        }));
        this.updateRole = this.actions$.ofType(Staff.REQUEST_UPDATE_ROLE).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.api
                .updateOrganisationRole(organisationId, action.payload.id, action.payload.role)
                .map(function (payload) { return Staff.ResponseSuccessUpdateRole(payload); })
                .catch(function (err) { return observableOf(Staff.ResponseFailUpdateRole(err)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "paginate", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "updateFilter", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "updatePagination", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "getStaff", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "searchStaff", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "countStaff", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "staffById", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], StaffEffects.prototype, "updateRole", void 0);
    return StaffEffects;
}());
export { StaffEffects };
